import React from "react";
import styles from "./MiniCardToggle.module.scss";
import { IoIosArrowDropup, IoIosArrowDropdown } from "react-icons/io";

const MiniCardToggle = ({
  title,
  image,
  footerContent,
  isOpen,
  onToggle,
}) => {
  return (
    <div className={styles.cardContainer} onClick={onToggle}>
      <div className={styles.cardHeader}>
        <h3>{title}</h3>
      </div>

      <div className={styles.cardImageWrapper}>
        <img src={image} alt={title} className={styles.cardImage} />
      </div>

      <div className={styles.cardFooter}>
        {footerContent}
        {isOpen ? (
          <IoIosArrowDropup className={styles.iconDropDown} />
        ) : (
          <IoIosArrowDropdown className={styles.iconDropDown} />
        )}
      </div>
    </div>
  );
};

export default MiniCardToggle;
